module.exports = __webpack_public_path__ + "workspace/static/img/downloadSignatureTwo.f0d0711.png";